var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30301 10.6667L0.333008 13V0.666667C0.333008 0.489856 0.403246 0.320286 0.52827 0.195262C0.653294 0.0702379 0.822863 0 0.999674 0H12.9997C13.1765 0 13.3461 0.0702379 13.4711 0.195262C13.5961 0.320286 13.6663 0.489856 13.6663 0.666667V10C13.6663 10.1768 13.5961 10.3464 13.4711 10.4714C13.3461 10.5964 13.1765 10.6667 12.9997 10.6667H3.30301ZM2.84167 9.33333H12.333V1.33333H1.66634V10.2567L2.84167 9.33333ZM6.33301 4.66667H7.66634V6H6.33301V4.66667ZM3.66634 4.66667H4.99967V6H3.66634V4.66667ZM8.99967 4.66667H10.333V6H8.99967V4.66667Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowAlert);
export default __webpack_public_path__ + "static/media/showAlert.7b17e2800781b0fad8deba8e7affe207.svg";
export { ForwardRef as ReactComponent };